@if (embededMode.active) {
<app-embeded-toolbar>
    <router-outlet> </router-outlet>
</app-embeded-toolbar>
} @else {
<app-side-nav-outer-toolbar title="{{ appInfo.title }}">
    <router-outlet> </router-outlet>
</app-side-nav-outer-toolbar>
}
